import { z } from "zod"

export const createLoginSchema = (t: (key: string) => string) =>
  z.object({
    email: z.string().min(1, t("required")).email(t("email")),
    password: z.string().min(1, t("required")).min(6, t("passwordMin")),
    rememberMe: z.boolean().optional()
  })

export type LoginFormData = z.infer<ReturnType<typeof createLoginSchema>>
